import { I as IconButton, d as defineCustomElement$1 } from './icon-button.js';

const TtIconButton = IconButton;
const defineCustomElement = defineCustomElement$1;

export { TtIconButton, defineCustomElement };
